import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Link as RouterLink } from 'react-router-dom';

export const LoginPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    maxWidth: '380px',
    boxSizing: 'border-box',
    padding: theme.spacing(3),
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}));

export const Form = styled('form')(({ theme }) => ({
    '& .MuiFormControl-root': {
        width: "100%",
        // marginTop: theme.spacing(1),
        // marginBottom: theme.spacing(1),
    }
}));


export const SubmitButton = styled(Button)(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing(3),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.dark,
    }
}));

export const SignUpButton = styled(Button)(({ theme }) => ({
    width: "100%",
    marginTop: 0,
    color: theme.daPalette.darkGrey.contrastText,
    backgroundColor: theme.daPalette.darkGrey.dark,
    borderColor: theme.daPalette.darkGrey.dark,
    '&:hover': {
        backgroundColor: theme.daPalette.darkGrey.main,
        borderColor: theme.daPalette.grey.dark,
    }
}));

export const ForgotPasswordLink = styled(RouterLink)(({ theme }) => ({
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
}));